import xhr from 'xhr'
import Promise from 'bluebird'
const STATUS_BAD_REQUEST = 400

const buildOptions = (url, options) => {
  const { sync, method, timeout, headers, data, responseType } = options
  // xhr options default to GET request without headers or timeout
  const opts = {
    url,
    sync: sync || false,
    method: method || 'GET',
    timeout: timeout || 2e4, // eslint-disable-line
    headers: headers || { 'Content-Type': 'application/json' },
    json: data || {}
  }
  if (responseType) {
    opts.responseType = responseType
  }

  return opts
}

export default function (endpoint, options) {
  Promise.config({ cancellation: true })

  if (!endpoint) throw new TypeError('request invoked without `endpoint`!')

  const request = new Promise((resolve, reject, onCancel) => {
    const xhrOptions = buildOptions(endpoint, (options || {}))
    const req = xhr(xhrOptions, (error, response, body) => {
      if (error) {
        reject(error)
      } else {
        const result = {
          body,
          statusCode: response.statusCode,
          xhr: response.rawRequest
        }
        if (response.statusCode < STATUS_BAD_REQUEST) {
          resolve(result)
        } else {
          reject(result)
        }
      }
    })
    onCancel(() => req.abort())
  })

  return request
}



// WEBPACK FOOTER //
// ./src/helpers/request.js